export default __webpack_public_path__ + "static/media/Girdle of the Victorious Elite.16b57638.jpg";